import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Search } from "lucide-react";
import api, { mediaUrl } from "@/lib/api";
import NewsCard from "@/components/public/NewsCard";
import { STATUS_STYLE } from "./Tournaments";

export default function SearchPage() {
  const [params, setParams] = useSearchParams();
  const q = params.get("q") || "";
  const [term, setTerm] = useState(q);
  const [news, setNews] = useState(null);
  const [tours, setTours] = useState([]);

  useEffect(() => {
    setTerm(q);
    if (!q) { setNews([]); setTours([]); return; }
    setNews(null);
    api.get("/news", { params: { q, limit: 24 } }).then((r) => setNews(r.data.items)).catch(() => setNews([]));
    api.get("/tournaments", { params: { q } }).then((r) => setTours(r.data.items)).catch(() => setTours([]));
  }, [q]);

  return (
    <div className="mx-auto max-w-7xl px-4 md:px-6 py-10" data-testid="search-page">
      <h1 className="text-4xl font-bold text-white">Search</h1>
      <form onSubmit={(e) => { e.preventDefault(); setParams(term.trim() ? { q: term.trim() } : {}); }} className="mt-5 relative max-w-2xl">
        <Search size={18} className="absolute left-4 top-1/2 -translate-y-1/2 text-white/40" />
        <input value={term} onChange={(e) => setTerm(e.target.value)} placeholder="Search news & tournaments…" data-testid="search-page-input"
          className="w-full pl-11 pr-4 py-3 rounded-full card-surface text-white placeholder:text-white/30 focus:outline-none focus:border-[hsl(var(--primary))]" />
      </form>
      {q && <p className="mt-4 text-sm text-white/50" data-testid="search-summary">{news === null ? "Searching…" : `${(news?.length || 0) + tours.length} results for “${q}”`}</p>}
      {tours.length > 0 && (
        <section className="mt-10">
          <h2 className="text-lg font-bold text-white mb-4">Tournaments</h2>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {tours.map((t) => {
              const st = STATUS_STYLE[t.status] || STATUS_STYLE.upcoming;
              return (
                <Link key={t.id} to={`/tournaments/${t.slug}`} className="flex gap-3 card-surface rounded-xl p-3 hover-rise" data-testid={`search-tournament-${t.slug}`}>
                  <div className="w-24 h-16 rounded-lg overflow-hidden bg-white/5 shrink-0">{t.cover && <img src={mediaUrl(t.cover)} alt="" className="w-full h-full object-cover" />}</div>
                  <div className="min-w-0"><span className="eyebrow" style={{ color: st.color }}>{st.label}</span><div className="font-bold text-white truncate">{t.name}</div><div className="text-xs text-white/40">{t.game}</div></div>
                </Link>
              );
            })}
          </div>
        </section>
      )}
      {news?.length > 0 && (
        <section className="mt-10">
          <h2 className="text-lg font-bold text-white mb-4">News</h2>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">{news.map((a) => <NewsCard key={a.id} article={a} />)}</div>
        </section>
      )}
      {q && news?.length === 0 && tours.length === 0 && <div className="mt-16 text-center text-white/40" data-testid="search-empty">Nothing found. Try another keyword.</div>}
    </div>
  );
}
